export function buildCaption(result) {
  const tag = (result.name || "").replace(/[^a-zA-Z]/g, "");
  return (
    `I drew ${result.name} — ${result.title}.\n\n` +
    `\u201C${result.statement}\u201D\n\n` +
    `\u2726 Discover your archetype at Sybils Society: The Return of the Matriarchs.\n\n` +
    `#SybilsSociety #TheReturnOfTheMatriarchs #${tag} #MatriarchalPower #OracleWisdom #DivineFeminine #AncientIntuition`
  );
}
